var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.info.position)?_c('div',{class:[("" + _vm.cssPrefix)],style:(_vm.rootStyle)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }